module.exports = __webpack_public_path__ + "img/blog.5463425a.png";